// @flow
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Toggle from 'react-toggle';
import classnames from 'classnames';
import './SimulationDashboardPage.scss';
import { DashboardContentContainer } from './DashboardContentContainer';
import ReportContainer from '../../reports/ReportContainer';

const scanLimit = 10;

type Props = {
  simulationList: ?Array<any>,
  getSimulations: Function,
  simulationDetails: Object,
  getSimulationReport: Function,
  lastEvaluatedKey: Object,
  toggleSimulationStatus: Function,
  resetSimulationDashboard: Function,
};

export default class SimulationDashboardPage extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      showReportDialog: false,
      active: false,
    };
  }
  componentDidMount() {
    this.props.getSimulations(0, scanLimit, null);
  }

  componentWillUnmount() {
    this.props.resetSimulationDashboard();
  }

  getNextSimulations = () => {
    const status = this.state.active ? 1 : 0;
    this.props.getSimulations(status, scanLimit, this.props.lastEvaluatedKey);
  };

  closeDialog = () => {
    this.showDialog(false);
  };

  showDialog = (show: boolean) => {
    this.setState({
      showReportDialog: show,
    });
  };

  loadDetailsHandler = (simulationID: string) => {
    this.props.getSimulationReport(simulationID);
    this.showDialog(true);
  };

  toggleActiveStatus = () => {
    const status = this.state.active ? 0 : 1;
    this.setState((state) => {
      const isActive = !state.active;
      return {
        active: isActive,
      };
    });
    this.props.toggleSimulationStatus(status, scanLimit);
  };

  props: Props;

  SimulationReportModal = (
    showReport: boolean,
    closeDialog: Function
  ) => {
    const contents = <ReportContainer
      details={this.props.simulationDetails}
    />;
    if (!showReport) {
      return null;
    }
    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Simulation Results Report</p>
            <button className="delete" aria-label="close" onClick={closeDialog} />
          </header>
          <section className="modal-card-body">
            {contents}
          </section>
          <footer className="modal-card-foot">
            <button className="button" onClick={closeDialog}>Cancel</button>
          </footer>
        </div>
      </div>
    );
  };

  render() {
    return (
      <DocumentTitle title="Marionette">
        <section className="section">
          <div className="container">
            <div className="is-horizontal">
              <div className="is-pulled-left field-label is-normal">
                <label className="label" htmlFor="toggle">
                  {this.state.active ? 'Active simulations' : 'All simulations'}
                </label>
              </div>
              <div className="field-body">
                <div className="field is-narrow">
                  <p className="control">
                    <Toggle
                      checked={this.state.active}
                      icons={false}
                      onChange={() => {
                        this.toggleActiveStatus();
                      }}
                    />
                  </p>
                </div>
              </div>
            </div>
            <DashboardContentContainer
              simulations={this.props.simulationList}
              loadDetails={this.loadDetailsHandler}
            />
            <a
              className={classnames('button is-primary', {
                'is-hidden': !this.props.lastEvaluatedKey,
              })}
              onClick={() => this.getNextSimulations()}
            >
              Load more
            </a>
            {this.SimulationReportModal(
              this.state.showReportDialog,
              this.closeDialog
            )}
          </div>
        </section>

      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/simulation/SimulationDashboardPage.jsx
 **/